import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Results',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M17.5 2.5h-3c-.5 1.2-1.3 2-2.5 2s-2-.8-2.5-2h-3l-6 4 2 5 3-2v12h13v-12l3 2 2-5-6-4z" }
      }), h("polygon", {
        attrs: { points: "11.5,11.9 12.3,11.9 12.5,11.1 11.7,11.1" }
      }), h("path", {
        attrs: { d: "M8 8v7h8V8H8zm6 3.1h-.8l-.2.8h.8v.7h-.9l-.2.9H12l.2-.9h-.8l-.2.9h-.7l.2-.9H10v-.7h.7l.2-.8h-.7v-.7h.9l.2-.9h.7l-.2.9h.8l.2-.9h.7l-.2.9h.7v.7z" }
      }), h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M16 2.5C16 4.4 14.2 6 12 6S8 4.4 8 2.5" }
      })]
    );
  }
};